/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Already_DeclinedInputs */

const en_application_already_declined = /** @type {(inputs: Application_Already_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This application is already declined.`)
};

const de_application_already_declined = /** @type {(inputs: Application_Already_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Bewerbung ist bereits abgelehnt.`)
};

/**
* | output |
* | --- |
* | "This application is already declined." |
*
* @param {Application_Already_DeclinedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const application_already_declined = /** @type {((inputs?: Application_Already_DeclinedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Already_DeclinedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_already_declined(inputs)
	return en_application_already_declined(inputs)
});